import { query, xenv, trackEvent } from '@didi/webx-js'

const commonParams = checkUrl => {
  return {
    prod_key: query().prod_key,
    dchn: query().dchn,
    xenv: xenv(),
    url: checkUrl || window?.location?.href,
    referer: window?.document?.referrer,
    from: query().from,
  }
}

export const TechPageUrlErrorTrack = (label = '', type = '', params = {}) => {
  console.log(
    `【TechPageUrlErrorTrack】-${type}%c${label}`,
    'color: yellow;background:green;'
  )
  // pub_quartz_page_url_error_sw
  // tech_quartz_page_url_error
  trackEvent('pub_quartz_page_url_error_sw', label, {
    ...commonParams(),
    type,
    extra: JSON.stringify({
      ...query(),
      ...(params || {}),
    }),
  })
}

export const TechPageErrorNoFromAndXenv = () =>
  TechPageUrlErrorTrack('小程序内来源缺少 from 和 xenv', '000012')

export const TechPageErrorFromError = () =>
  TechPageUrlErrorTrack('from 错误', '00013')

export const TechPageErrorNoXenv = () =>
  TechPageUrlErrorTrack('小程序内来源缺少 xenv', '00014')

export const TechPageErrorXenvError = () => {
  TechPageUrlErrorTrack('小程序内 xenv 错误', '00015')
}

export const TechPageErrorXenvNotEqualUrl = () => {
  TechPageUrlErrorTrack('url携带的xenv与当前xenv()不相符', '00016')
}

export const TechPageErrorMiniQueryError = name => {
  TechPageUrlErrorTrack(name, '00016')
}

export const TechPageErrorIsOld = () => {
  TechPageUrlErrorTrack('Old页面', '00017')
}

export const TechPageErrorIsNotChiTuUrl = () => {
  TechPageUrlErrorTrack('非赤兔套餐产品创建的短链', '00018')
}

export const TechPageErrorUrlNotHasKeyParams = name => {
  TechPageUrlErrorTrack(name, '00019')
}

export const TechPageErrorOrderNoSendUid = params => {
  TechPageUrlErrorTrack('订单详情没send_uid，取默认逻辑判断', '00020', params)
}

export const TechPageErrorIsLongUrl = () => {
  TechPageUrlErrorTrack('微信H5下，投放的长链接', '00021')
}

export const TechPageErrorCancelOrderFail = params => {
  TechPageUrlErrorTrack('取消订单失败', '00022', params)
}

export const TechPageErrorGetApolloFail = () => {
  TechPageUrlErrorTrack('获取apollo失败', '00023')
}

export const TechPageErrorDyCreateNoOpenid = params => {
  TechPageUrlErrorTrack('抖音下单没有openid', '00024', params)
}

export const TechPageErrorDyPayNoOpenid = params => {
  TechPageUrlErrorTrack('抖音支付没有openid', '00025', params)
}

export const TechPageErrorNotNormalXenv = () => {
  TechPageUrlErrorTrack('投放环境异常-非支持环境', '00026')
}

// 以下用于统计旧页面是否还使用，当无数据时可下掉页面 & 埋点
export const TechPageInSpikeDetail = () => {
  TechPageUrlErrorTrack('page_spikeDetail', '00027')
}

export const TechPageInSpikeDetailOld = () => {
  TechPageUrlErrorTrack('page_spikeDetailOld', '00028')
}

export const TechPageInOrderDetailOldOld = () => {
  TechPageUrlErrorTrack('page_orderDetailOld', '00029')
}

export const TechPageInIndexOld = () => {
  TechPageUrlErrorTrack('page_indexOld', '00030')
}

export const TechPageInPersonalOld = () => {
  TechPageUrlErrorTrack('page_personalOld', '00031')
}

export const TechPageInGoodsDetailOld = () => {
  TechPageUrlErrorTrack('goodsDetailOld', '00032')
}

export const TechGoodsDetailCreateOrderError = data =>
  TechPageUrlErrorTrack('商品详情页下单失败', '000033', data)

export const TechGoodsProcessCreateOrderError = data =>
  TechPageUrlErrorTrack('进行中页面下单失败', '000033', data)
